import { mergeAttributes, Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'

import { TokenComponent } from './TokenComponent'

export const Token = Node.create({
  name: 'token',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      name: {
        default: 'token',
      },
      label: {
        default: 'My Label',
      },
    }
  },

  renderText({ node }) {
    return `{{token:${node.attrs.name}}}`
  },

  parseHTML() {
    return [{ tag: 'token' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['token', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(TokenComponent)
  },
})
